module.exports = __webpack_public_path__ + "img/dead-tree-desert-01.37ac9f47.png";